import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

import { PROVIDER_DETAIL_STYLES } from "../../styles";

export default function ProviderDetailSectionTitle({ children }) {
  return (
    <Typography
      className="text-[16px] font-semibold"
      sx={PROVIDER_DETAIL_STYLES.primarySectionTitle}
    >
      {children}
    </Typography>
  );
}

ProviderDetailSectionTitle.propTypes = {
  children: PropTypes.node.isRequired,
};
